var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyDraftsPrism16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6.25v-2.5a2 2 0 00-2-2h-8.5a2 2 0 00-2 2v2.5h12.5z",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12.25A2.75 2.75 0 0112.25 15h-8.5A2.75 2.75 0 011 12.25v-8.5A2.75 2.75 0 013.75 1h8.5A2.75 2.75 0 0115 3.75zM13.5 7h-11v5.25c0 .647.492 1.18 1.122 1.244l.128.006h8.5c.69 0 1.25-.56 1.25-1.25V7zm-1.25-4.5h-8.5l-.128.006A1.25 1.25 0 002.5 3.75V5.5h11V3.75c0-.69-.56-1.25-1.25-1.25z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7v1h7.5v1.5H6V11h7.5v1.5H6v1H4.5v-1h-2V11h2V9.5h-2V8h2V7H6z",
    fillRule: "nonzero",
    opacity: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDraftsPrism16);
export default __webpack_public_path__ + "static/media/my-drafts-prism-16.af8e73b5.svg";
export { ForwardRef as ReactComponent };